"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useCurrentPageContent = _interopRequireDefault(require("../../../hooks/app/useCurrentPageContent"));
var _questionnaireSelectors = require("../../../store/questionnaire/questionnaireSelectors");
var _constants = require("../../../utils/constants");
var _useAppSelector = require("../../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DynamicRecommendationPlans = props => {
  const {
    flags
  } = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  const useAlternative = flags ? flags[_constants.ALTERNATIVE_RECOMMENDATION_FLAGS.ALTERNATIVE_PLANS_FLAG] : null;
  const {
    plans: Plans,
    alternativePlans: AlternativePlans
  } = (0, _useCurrentPageContent.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "dynamic-recommendation-plans"
  }, useAlternative && AlternativePlans ? /*#__PURE__*/_react.default.createElement(AlternativePlans, props) : !useAlternative && Plans ? /*#__PURE__*/_react.default.createElement(Plans, props) : null);
};
var _default = DynamicRecommendationPlans;
exports.default = _default;